import { render, staticRenderFns } from "./Biz.vue?vue&type=template&id=14051ae2&"
import script from "./Biz.vue?vue&type=script&lang=js&"
export * from "./Biz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports